import { Component, computed, effect, inject, input, model, TemplateRef, viewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ClassValue } from 'clsx';
import { bui } from '../utils';

@Component({
  selector: 'alert-dialog',
  exportAs: 'alertDialog',
  template: `
    <ng-template #content>
      <div [class]="computedClass()">
        <ng-content />
      </div>
    </ng-template>
  `,
})
export class AlertDialog {
  // Dependencies
  private dialog = inject(MatDialog);

  // Inputs / Outputs
  readonly open = model<boolean>(false);
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // Queries
  private content = viewChild.required<TemplateRef<unknown>>('content');

  // State
  private dialogRef: MatDialogRef<unknown> | undefined = undefined;
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'mat-mdc-dialog-component-host',
      'flex max-w-md flex-col gap-y-3',

      // User classes
      this.userClass(),
    ),
  );

  constructor() {
    // Open or close the dialog based on the `open` state
    effect(() => {
      const open = this.open();
      const content = this.content();

      if (!content) {
        return;
      }

      if (open) {
        // Open
        this.dialogRef = this.dialog.open(content, {
          disableClose: true,
        });
      } else {
        // Close
        this.dialogRef?.close();
        this.dialogRef = undefined;
      }
    });
  }
}
